import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgKgEyedropper = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M17.041 12.025 6.91 22.156 1 23l.844-5.91L11.975 6.96m0-5.067 10.132 10.132M19.8 9l2.206-2.207a3.396 3.396 0 0 0 0-4.8 3.397 3.397 0 0 0-4.8 0L15 4.2"
	})
});
export default SvgKgEyedropper;
